module.exports = __webpack_public_path__ + "img/anime-character.07681230.jpg";